import type { BubbleProps } from './features/Bubble'

export const defaultBubbleProps: BubbleProps = {
  apiHost: undefined,
  autoShowDelay: undefined,
  brandColor: undefined,
  isPreview: undefined,
  beeetleBot: undefined,
  onAnswer: undefined,
  onClose: undefined,
  onEnd: undefined,
  onInit: undefined,
  onNewInputBlock: undefined,
  onOpen: undefined,
  onPreviewMessageClick: undefined,
  prefilledVariables: undefined,
  previewMessage: undefined,
  resultId: undefined,
  theme: {
    button: {
      backgroundColor: undefined,
      customCloseIconSrc: undefined,
      customIconSrc: undefined,
      iconColor: undefined,
      size: undefined,
    },
    chatWindow: {
      backgroundColor: undefined,
      maxHeight: undefined,
      maxWidth: undefined,
    },
    placement: undefined,
    previewMessage: {
      backgroundColor: undefined,
      closeButtonBackgroundColor: undefined,
      closeButtonIconColor: undefined,
      textColor: undefined,
    },
  },
}
